import * as yup from 'yup'

const legalEntityValidationSchema = yup.object().shape({
  rcs: yup
    .string()
    .default('')
    .when(['isRcsRegistering', 'checked'], (values, schema) => {
      const [isRcsRegistering, checked] = values as [boolean, boolean];
      const shouldValidate = !(isRcsRegistering || !checked);

      return shouldValidate
        ? schema
            .required('Le numéro RCS est requis')
            .matches(/^\d{9}$/, 'Le RCS doit contenir 9 chiffres')
        : schema.notRequired().nullable();
    }),

  companyName: yup
    .string()
    .required("Le nom de l'entreprise est requis")
    .min(2, 'Le nom doit faire au moins 2 caractères'),

  legalForm: yup.string().required('La forme juridique est requise'),

  capital: yup
    .number()
    .required('Le capital est requis')
    .positive('Le capital doit être positif'),

  postalCode: yup
    .string()
    .required('Le code postal est requis')
    .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),

  city: yup.string().required('La ville est requise'),
  address: yup.string().required("L'adresse est requise"),
  registrationOffice: yup.string().required("Le bureau d'enregistrement est requis")
});


export default legalEntityValidationSchema;